import { render, staticRenderFns } from "./EmployeeUpcomingPanel.vue?vue&type=template&id=3b16a83a&scoped=true&"
import script from "./EmployeeUpcomingPanel.vue?vue&type=script&lang=js&"
export * from "./EmployeeUpcomingPanel.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeUpcomingPanel.vue?vue&type=style&index=0&id=3b16a83a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16a83a",
  null
  
)

export default component.exports